/**
 * Pill — base styled pill used in headers, filters, badges.
 *
 * Restyled to the 5mi.uz warm pastel design:
 *   - default   outline surface pill (utility actions)
 *   - cta       solid coral (primary CTA)
 *   - active    solid coral (active filter chip)
 *   - ghost     transparent
 *
 * Modifier `iconOnly` → fixed 32x32 square.
 * Accepts `as` to render as button/a/Link (defaults to <button>).
 */
import { forwardRef } from 'react'

const BASE =
  'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium ' +
  'transition-all whitespace-nowrap select-none cursor-pointer border outline-none ' +
  'focus-visible:ring-2'

const VARIANT_STYLE = {
  default: { background: 'var(--surface)', borderColor: 'var(--border)', color: 'var(--ink-2)' },
  cta: {
    background: 'var(--coral)', borderColor: 'transparent', color: '#fff',
    fontWeight: 600, boxShadow: '0 6px 16px rgba(255,122,82,.35)',
  },
  active: { background: 'var(--coral)', borderColor: 'transparent', color: '#fff', fontWeight: 600 },
  ghost: { background: 'transparent', borderColor: 'transparent', color: 'var(--ink-2)' },
}

const Pill = forwardRef(function Pill(
  { as: As = 'button', variant = 'default', iconOnly = false, className = '', style, children, ...props },
  ref,
) {
  const sizeCls = iconOnly ? 'w-8 h-8 p-0 justify-center' : ''
  return (
    <As
      ref={ref}
      className={`${BASE} ${sizeCls} ${className}`}
      style={{ ...(VARIANT_STYLE[variant] ?? VARIANT_STYLE.default), ...style }}
      {...props}
    >
      {children}
    </As>
  )
})

export default Pill
